class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const clickedOutside = !this.contains(event.target);
    const clickedOverlay = event.target.classList && event.target.classList.contains('modal-overlay');
    if (!clickedOutside && !clickedOverlay) return;
    if (this.classList.contains('header__search')) {
      const headerWrapper = document.querySelector('.header-wrapper');
      if (headerWrapper && headerWrapper.contains(event.target) && !clickedOverlay) return;
    }
    this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    if (this.classList.contains('header__search')) {
      const headerWrapper = document.querySelector('.header-wrapper');
      if (headerWrapper) {
        const openDetails = headerWrapper.querySelectorAll('details[open]');
        openDetails.forEach((detailsEl) => {
          if (this.detailsContainer && detailsEl === this.detailsContainer) return;
          detailsEl.removeAttribute('open');
        });
      }
    }
    event.target.closest('details').setAttribute('open', true);
    document.body.classList.add('overflow-hidden');
    // Defer so the opening click does not bubble to body and immediately close the modal
    const self = this;
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (self.detailsContainer && self.detailsContainer.hasAttribute('open')) {
          document.body.addEventListener('click', self.onBodyClickEvent);
        }
      });
    });

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
